import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';

import { decodeToken } from './utils/jwt.utils';

const PostHogPageViewTracker = () => {
  const location = useLocation();
  const postHog = usePostHog();
  const posthogDetails = localStorage.getItem('posthogdetails');
  const token = localStorage.getItem('token');
  useEffect(() => {
    if (postHog) {
      if(posthogDetails) {
        const posthogDetailsParsed = JSON.parse(posthogDetails);
        postHog.capture('$pageview', {
            viewAsUserName: posthogDetailsParsed?.userProperties?.viewAsUserName || "",
            viewAsUserEmail: posthogDetailsParsed?.userProperties?.viewAsUserEmail || "",
            internalTeam: posthogDetailsParsed?.userProperties?.internalTeam || false,
        });
      } else {
        let internalTeam = false; // for handling the /login screen
        if(token) {
          const { isStaff } = decodeToken(token);
          internalTeam = isStaff;
        };
        postHog.capture('$pageview', {
          internalTeam: internalTeam
        });
      }
    }
  }, [location, postHog]);
  return null;
};
export default PostHogPageViewTracker;
